import WebsiteServiceModel from '@/models/WebsiteServiceModel';
import doc                 from '@widesk-core/decorators/doc';

export default class WebsiteModel extends WebsiteServiceModel {
	private declare _tsFilters: {
		'createdAt[before]': string | Date;
		'createdAt[strictly_before]': string | Date;
		'createdAt[after]': string | Date;
		'createdAt[strictly_after]': string | Date;
		'updatedAt[before]': string | Date;
		'updatedAt[strictly_before]': string | Date;
		'updatedAt[after]': string | Date;
		'updatedAt[strictly_after]': string | Date;
		'name': id;
		'url': id;
		'showUrn': Urn;
		'search': string;
	};

	static get path(): string {
		return 'websites/{?id}';
	}

	@doc.string declare name: string;
	@doc.string declare url: string;
	@doc.string declare createdBy: string;
	@doc.string declare updatedBy: string;
	@doc.date declare createdAt: Dayjs;
	@doc.date declare updatedAt: Dayjs;
}